export { MaterialModule } from './material/material.module';
export { PrimengModule } from './primeng/primeng.module';